import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Plus, ShieldCheck } from 'lucide-react';
import { getProductImage } from '@/lib/health';

export const HealthProductCard = ({ product, formatLocalPrice, index = 0 }) => {
  const compare = product.original_price;
  const discount = compare && compare > product.price ? Math.round((1 - product.price / compare) * 100) : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay: (index % 8) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
    >
      <Link
        to={`/products/${product.id}`}
        className="group block bg-white rounded-3xl border border-health-line shadow-soft hover:shadow-lift overflow-hidden transition-shadow duration-300"
        data-testid={`product-card-${product.id}`}
      >
        <div className="relative aspect-square overflow-hidden bg-health-mint/60 m-2 rounded-2xl">
          <img
            src={getProductImage(product)}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            loading="lazy"
          />
          {discount > 0 && (
            <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-health-coral text-white text-xs font-bold shadow-badge">
              -{discount}%
            </span>
          )}
          <span className="absolute bottom-3 right-3 w-10 h-10 rounded-full bg-white text-health-emerald flex items-center justify-center shadow-soft translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-300">
            <Plus className="h-5 w-5" />
          </span>
        </div>
        <div className="px-4 pb-5 pt-2">
          <p className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-health-emerald mb-1">
            <ShieldCheck className="h-3 w-3" /> {product.category}
          </p>
          <h3 className="font-heading text-[15px] font-semibold text-health-ink line-clamp-2 min-h-[2.6rem] leading-snug">
            {product.name}
          </h3>
          <div className="flex items-baseline gap-2 mt-2">
            <span className="font-heading text-lg font-bold text-health-ink" data-testid={`product-card-price-${product.id}`}>
              {formatLocalPrice(product.price)}
            </span>
            {discount > 0 && (
              <span className="text-sm text-slate-400 line-through">{formatLocalPrice(compare)}</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default HealthProductCard;
